import React, { useState, Fragment } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { useParams } from "react-router-dom";
import { DateFormat } from '../../../hooks/dateFormat'
import { CONSTANTS } from '../../../constants';
const dateToInputFormat = (date) => {
    if (!date) {
        return null
    }
    const month = pad(date.getMonth() + 1)
    const day = pad(date.getDate())
    const hours = pad(date.getHours())
    const minutes = pad(date.getMinutes())
    return `${date.getFullYear()}-${month}-${day}T${hours}:${minutes}`
}
const pad = (input) => {
    return input < 10 ? "0" + input : input
}
const Modal = ({ children, onClose, title, className, setShowingEventForm }) => {
    return (
        <Fragment>
            <div className="overlay" onClick={onClose} />
            <div className={`modal-popup`}>
                <button style={{ marginTop: 10, marginRight: 15, fontSize: 35 }} type="button" className="close" onClick={() => setShowingEventForm({ visible: false })}>&times;</button>
                <h3>{title}</h3>

                <div className="inner">
                    {children}
                </div>
            </div>
        </Fragment>
    )
}

const EventForm = (props) => {

    const { campaignSettingSaved, dateEvents, setShowingEventForm, withEvent, preselectedDate } = props;
    const newEvent = withEvent || {}
    if (!withEvent && !!preselectedDate) {
        newEvent.dateFrom = dateToInputFormat(preselectedDate)
    }
    const [event] = useState(newEvent)
    const {CURRENCY} = CONSTANTS;
    const { userId } = useParams();
    const [eventTypes,setEventTypes] = useState([]);
    React.useEffect(() => {
        if(userId){
            setEventTypes([
                { value: 'cost_per_click', label: 'Cost Per Click' },
                { value: 'cost_per_view', label: 'Cost Per View' }
            ]);
            
        }else{
            setEventTypes([
                { value: 'ads_per_post', label: 'Posts Per Ad' },
                { value: 'fequency_caps', label: 'Fequency Caps Per Day' },
                { value: 'cost_per_click', label: 'Cost Per Click' },
                { value: 'cost_per_view', label: 'Cost Per View' }
            ]);
        }
    }, [userId]);
    
    
    const [date, setDate] = useState(null);
    const [settingType, setSettingType] = useState('');
    const [settingValue, setSettingValue] = useState('');

    React.useEffect(() => {
        campaignSettingSaved && setShowingEventForm({ visible: false })
    }, [campaignSettingSaved]);

    React.useEffect(() => {
        if (event.dateFrom)
            setDate(event.dateFrom)
        if (event.type)
            setSettingType(event.type)
        if (event.value)
            setSettingValue(event.value)
    }, [event])

    const handleSubmit = () => {

        console.log('settingType', settingType)

        console.log('eventTypes', eventTypes)
        const payload = {
            date_from: DateFormat(date, 'YYYY-MM-DD')+' 00:00:00',
            date_to: DateFormat(date, 'YYYY-MM-DD')+' 23:59:59',
            setting_key: settingType,
            setting_value: settingValue,
            setting_label: eventTypes.find((item) => item.value === settingType).label,
            user_id:userId
        }
        props.saveCampaignSetting(payload);
    }

    return (
        <Modal setShowingEventForm={setShowingEventForm} onClose={() => setShowingEventForm({ visible: false })} title={`${withEvent ? `Edit ${event.name}` : "Add New Setting"}`}>
            <div className="form">
                <FormGroup>
                    <Label for={'name'}>{'Date'}</Label>
                    <Input
                        readOnly={true}
                        type="text"
                        name="date"
                        id="date"
                        value={DateFormat(date)}
                        autoComplete={'off'}
                    />
                </FormGroup>


                <FormGroup>
                    <Label for={'name'}>Type</Label>
                    {event.value ?
                        <Input
                            readOnly={true}
                            type="text"
                            name="date"
                            id="date"
                            value={event.name}
                            autoComplete={'off'}
                        />
                        : <Input name={'transaction_type'}
                            onChange={(e) => setSettingType(e.target.value)}
                            className="mb-2"
                            type="select" defaultValue={settingType}
                            style={{ width: '100%' }}>
                            <option value={0}>Select</option>
                            {
                                eventTypes.map((item) => {
                                    if (dateEvents.findIndex((selectedEvents) => item.value === selectedEvents.type) < 0)
                                        return <option key={item.value} value={item.value}>{item.label}</option>
                                    else
                                        return null
                                }
                                )
                            }
                        </Input>
                    }
                </FormGroup>

                {(settingType === 'cost_per_click' || settingType === 'cost_per_view') ?
                    <FormGroup>
                        <Label for={'name'}>{'Amount'}</Label>
                        <div class="currency-wrap">
                            <span class="currency-code">{CURRENCY}</span>
                            <Input
                                type="number"
                                className="text-currency"
                                name="amount"
                                id="amount"
                                onChange={(e) => setSettingValue(e.target.value)}
                                autoComplete={'off'}
                                value={settingValue}
                            />
                        </div>
                    </FormGroup>

                    : <FormGroup>
                        <Label for={'name'}>{'Value'}</Label>
                        <Input
                            type="number"
                            name="amount"
                            id="amount"
                            onChange={(e) => setSettingValue(e.target.value)}
                            autoComplete={'off'}
                            value={settingValue}
                        />
                    </FormGroup>
                }
                <Button
                    size="sm"
                    color="primary"
                    className="border-0"
                    block
                    onClick={handleSubmit}
                >Add
                </Button>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaignSettingSaved: (state.campaign && state.campaign.campaignSettingSaved) ? state.campaign.campaignSettingSaved : null,
});
const mapDispatchToProps = (dispatch) => ({
    saveCampaignSetting: (payload) => dispatch(CampaignAction.saveCampaignSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventForm);
